/**
 * Created by AlexanderC on 6/16/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InMemoryDriver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractDriver2 = require('./AbstractDriver');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * In memory driver implementation
 */
let InMemoryDriver = exports.InMemoryDriver = function (_AbstractDriver) {
  _inherits(InMemoryDriver, _AbstractDriver);

  function InMemoryDriver() {
    _classCallCheck(this, InMemoryDriver);

    var _this = _possibleConstructorReturn(this, (InMemoryDriver.__proto__ || Object.getPrototypeOf(InMemoryDriver)).call(this));

    _this._storage = {};
    return _this;
  }

  /**
   * @returns {String}
   * @private
   */


  _createClass(InMemoryDriver, [{
    key: '_type',
    value: function _type() {
      return 'InMemory';
    }

    /**
     * @returns {Object}
     */

  }, {
    key: '_has',


    /**
     * @param {String} key
     * @param {Function} callback
     * @returns {Function}
     */
    value: function _has(key) {
      let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};

      if (!this._storage.hasOwnProperty(key)) {
        return callback(null, false);
      } else if (this._storage[key][1] === false) {
        return callback(null, true);
      }

      let timedOut = this._storage[key][1] < InMemoryDriver._now;

      if (timedOut) {
        this._invalidate(key);

        return callback(null, false);
      }

      return callback(null, true);
    }

    /**
     * @param {String} key
     * @param {Function} callback
     * @returns {Function}
     */

  }, {
    key: '_get',
    value: function _get(key) {
      let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};

      if (!this._storage.hasOwnProperty(key)) {
        return callback(null, null);
      } else if (this._storage[key][1] === false) {
        return callback(null, this._storage[key][0]);
      }

      let timedOut = this._storage[key][1] < InMemoryDriver._now;

      if (timedOut) {
        this._invalidate(key);

        return callback(null, null);
      }

      return callback(null, this._storage[key][0]);
    }

    /**
     * @param {String} key
     * @param {*} value
     * @param {Number} ttl
     * @param {Function} callback
     */

  }, {
    key: '_set',
    value: function _set(key, value) {
      let ttl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      let callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : () => {};

      this._storage[key] = [value, ttl <= 0 ? false : InMemoryDriver._now + ttl];

      callback(null, true);
    }

    /**
     * @param {String} key
     * @param {Number} timeout
     * @param {Function} callback
     */

  }, {
    key: '_invalidate',
    value: function _invalidate(key) {
      let timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};

      if (timeout <= 0) {
        delete this._storage[key];

        callback(null, true);

        return;
      }

      this._storage[key][1] = InMemoryDriver._now + timeout;

      callback(null, true);
    }

    /**
     * @param {Function} callback
     */

  }, {
    key: '_flush',
    value: function _flush() {
      let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};

      this._storage = {};

      callback(null, true);
    }

    /**
     * @returns {Number}
     * @private
     */

  }, {
    key: 'storage',
    get: function get() {
      return this._storage;
    }
  }], [{
    key: '_now',
    get: function get() {
      return parseInt(new Date().getTime() / 1000);
    }
  }]);

  return InMemoryDriver;
}(_AbstractDriver2.AbstractDriver);


//////////////////
// WEBPACK FOOTER
// ../~/deep-cache/lib.compiled/Driver/InMemoryDriver.js
// module id = 158
// module chunks = 0